/* ============================================================================
   SVNTY — THE BLACK CARD'S SHEEN (Part24, P24-2; snippets/svnty-gcard.liquid)
   One band of light over the card, painted once in CSS; this file only moves it (a transform, so the compositor does the
   work and the type never repaints). A hovering pointer leads the band; a phone sees ONE slow sweep the first time the card
   is well in view; reduced motion keeps the band where it rests. No tilt (Safari softens type in a perspective layer), no
   gyroscope (iOS asks a permission for it). Classic deferred script, no dependencies; every card is armed once, including a
   card drawn later (the account's invoice lines, a re-rendered section), through a MutationObserver on <body>.
   ============================================================================ */
(function () {
  if (window.svntyGcard) return;
  window.svntyGcard = true;

  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var fine = mq('(hover: hover) and (pointer: fine)').matches;
  var still = mq('(prefers-reduced-motion: reduce)').matches;
  var REST = -6;

  function arm(card) {
    if (card.svntyGcard) return;
    card.svntyGcard = true;
    var sheen = card.querySelector('.svnty-gcard__sheen');
    if (!sheen || still) return;                       /* reduced motion: the band rests, painted by CSS */
    card.classList.add('is-live');
    var x = REST, raf = 0;
    var paint = function () { raf = 0; sheen.style.transform = 'translate3d(' + x.toFixed(2) + '%,0,0)'; };
    var queue = function () { if (!raf) raf = window.requestAnimationFrame(paint); };
    if (fine) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        if (!r.width) return;
        x = ((e.clientX - r.left) / r.width - 0.5) * 24;   /* +/-12 % of the 220 % layer */
        queue();
      });
      card.addEventListener('pointerleave', function () { x = REST; queue(); });
      return;
    }
    if (typeof IntersectionObserver !== 'function' || typeof sheen.animate !== 'function') return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0] || !entries[0].isIntersecting) return;
      io.disconnect();
      sheen.animate(
        [{ transform: 'translate3d(-22%,0,0)' }, { transform: 'translate3d(14%,0,0)' }],
        { duration: 1600, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' }
      );
    }, { threshold: 0.6 });
    io.observe(card);
  }

  function armAll(root) {
    var cards = (root || document).querySelectorAll('.svnty-gcard');
    for (var i = 0; i < cards.length; i++) arm(cards[i]);
  }

  function start() {
    armAll(document);
    if (typeof MutationObserver !== 'function') return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; armAll(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
